import { Building2, ClipboardList, Image, Megaphone } from 'lucide-react'
import { LineItemsApi } from '@/services/lineItems/lineItemsApi'
import { OrdersApi } from '@/services/orders/ordersApi'
import type { SearchMode, SearchModeConfig } from './types'

/** What the palette searches for, and what it does with a result. */
export const SEARCH_MODES: Record<SearchMode, SearchModeConfig> = {
  advertisers: {
    type: 'Advertiser',
    icon: Building2,
    path: (id) => `/advertising/advertisers/${id}`,
    key: 'advertiser',
  },
  lineItems: {
    type: 'LineItem',
    icon: Megaphone,
    path: (id) => `/advertising/lineitems/${id}`,
    key: 'lineItem',
    // Search only returns names, so the parent advertiser is fetched separately.
    loadSubtitles: async (ids) => {
      const lineItems = await LineItemsApi.getByIds(ids)
      return Object.fromEntries(
        lineItems.filter((li) => li.advertiserName).map((li) => [li.id, li.advertiserName]),
      )
    },
  },
  orders: {
    type: 'Order',
    icon: ClipboardList,
    path: (id) => `/advertising/orders/${id}`,
    key: 'order',
    // Search only returns names, so the parent advertiser is fetched separately.
    loadSubtitles: async (ids) => {
      const orders = await OrdersApi.getByIds(ids)
      return Object.fromEntries(
        orders.filter((o) => o.advertiserName).map((o) => [o.id, o.advertiserName]),
      )
    },
  },
  creatives: {
    type: 'Creative',
    icon: Image,
    path: (id) => `/advertising/creatives/${id}`,
    key: 'creative',
  },
}
